import { useState, useEffect } from "react";
import DashboardLayout from "../common/DashboardApp";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  getProfileData,
  getIndustryData,
  getCities,
  uploadCompanyProfileImage,
  uploadCompanyProfileData,
  uploadGSTProfile,
} from "../../../service/employerapi";

const EmployerProfile = () => {
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState({});
  const [btnloading, setBtnLoading] = useState(false);
  const [imgBtnloading, setImgBtnLoading] = useState(false);
  const [gstBtnloading, setGstBtnLoading] = useState(false);
  const [responseIndustry, setResponseIndustry] = useState([]);
  const [responseCity, setResponseCity] = useState([]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getProfileData();
        if (res.status && res.data) {
          setProfile(res.data);
        }

        console.log(res);

        const resind = await getIndustryData();
        if (resind.status && resind.data) {
          setResponseIndustry(resind.data);
        }

        const rescity = await getCities();
        if (rescity.data.status && rescity.data.data) {
          setResponseCity(rescity.data.data);
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfile();
  }, []);

  const industryOptions =
    responseIndustry?.map((industry) => ({
      value: industry.name,
      label: industry.name,
    })) || [];

  const cityOptions =
    responseCity?.map((city) => ({
      value: city,
      label: city,
    })) || [];

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfile((prev) => ({
          ...prev,
          image: reader.result,
          imageFile: file,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleProfileUpload = async (e) => {
    e.preventDefault();

    if (!profile.imageFile) {
      alert("Please select an image first");
      return;
    }

    try {
      setImgBtnLoading(true);
      const res = await uploadCompanyProfileImage(profile.imageFile);
      if (res.data.status) {
        toast.success(res.data.message);
        setProfile((prev) => ({ ...prev, image: profile.image }));
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error("Upload error:", err);
      toast.error("Upload failed");
    } finally {
      setImgBtnLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Handle employerType toggle
    if (name === "employerType") {
      setProfile((prev) => ({
        ...prev,
        employerType: value,
        ...(value === "individual" && {
          gstNumber: "",
          certificate: null,
          gstCertificate: null,
        }),
      }));
      return;
    }

    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfileDetailsUpload = async (e) => {
    e.preventDefault();
    try {
      setBtnLoading(true);

      const profileData = {
        employerType: profile.employerType, // NEW FIELD
        companyName: profile.companyName,
        industryType: profile.industryType,
        contactPersonName: profile.contactPersonName,
        email: profile.email,
        companyAddress: profile.companyAddress,
        city: profile.city,
        pincode: profile.pincode,
        aboutCompany: profile.aboutCompany,
        otherIndustryName: profile.otherIndustryName,
        DPAgreement: profile.DPAgreement || false,
      };

      console.log(profileData);
      const response = await uploadCompanyProfileData(profileData);

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response?.data?.message || "Update failed");
    } finally {
      setBtnLoading(false);
    }
  };

  const handleGSTUpload = async (e) => {
    e.preventDefault();

    try {
      setGstBtnLoading(true);

      const formData = new FormData();
      formData.append("employerType", "company");
      formData.append("certificate", profile.certificate);
      formData.append("gstNumber", profile.gstNumber);
      // console.log(formData);

      const res = await uploadGSTProfile(formData);

      if (res.data.status) {
        toast.success("GST Details Updated Successfully");
        setProfile((prev) => ({
          ...prev,
          gstCertificate:
            res.data.gstCertificate || res.data.data?.gstCertificate,
          certificate: null,
        }));
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error("Failed to upload GST certificate");
    } finally {
      setGstBtnLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="panelCard profileCard">
          <div className="row">
            {/* LEFT PANEL */}
            <div
              className="col-md-4 d-flex profile-card"
              style={{ flexDirection: "column" }}
            >
              {/* PROFILE IMAGE */}
              <div className="mb-3 text-center">
                <label className="form-label fw-bold">
                  Update Profile Image
                </label>
                <form onSubmit={handleProfileUpload}>
                  <div
                    className="avatar-upload"
                    style={{ margin: "20px auto" }}
                  >
                    <div className="avatar-edit">
                      <input
                        type="file"
                        id="imageUpload"
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                      <label htmlFor="imageUpload"></label>
                    </div>

                    <div className="avatar-preview">
                      <div
                        id="imagePreview"
                        style={{
                          backgroundImage: `url(${
                            profile.image ||
                            "/assets/img/candidate-profiles/img1.jpg"
                          })`,
                        }}
                      ></div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="outlineBtn"
                    disabled={imgBtnloading}
                  >
                    {imgBtnloading ? "Updating..." : "Update Image"}
                  </button>
                </form>
              </div>

              <hr style={{ width: "100%", border: "1px solid #270b79" }} />

              {/* GST SECTION – ONLY FOR COMPANY */}
              {profile.employerType === "company" && (
                <div className="mt-3 text-left">
                  <div className="mb-3">
                    {profile?.gstCertificate && (
                      <a
                        href={profile.gstCertificate}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          border: "1px solid #eb642d",
                          padding: "6px 20px",
                          borderRadius: "10px",
                          color: "#eb642d",
                          textDecoration: "none",
                        }}
                      >
                        View GST Certificate
                      </a>
                    )}
                  </div>

                  <form onSubmit={handleGSTUpload}>
                    <div className="form-group mb-3">
                      <label>GST Number *</label>
                      <input
                        type="text"
                        className="form-control"
                        name="gstNumber"
                        value={profile.gstNumber || ""}
                        onChange={(e) =>
                          handleInputChange({
                            target: {
                              name: "gstNumber",
                              value: e.target.value.toUpperCase(),
                            },
                          })
                        }
                        minLength={15}
                        maxLength={15}
                        required
                      />
                    </div>

                    <label className="form-label">Select GST Certificate</label>
                    <div className="upload-box border rounded p-2 d-flex justify-content-between">
                      <span>
                        {profile?.certificate
                          ? profile.certificate.name
                          : "No file chosen"}
                      </span>

                      <label
                        htmlFor="certificate"
                        className="btn btn-sm btn-outline-primary"
                      >
                        Browse
                      </label>

                      <input
                        type="file"
                        id="certificate"
                        className="d-none"
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            certificate: e.target.files[0],
                          })
                        }
                      />
                    </div>

                    <button type="submit" className="outlineBtn w-100 mt-3">
                      {gstBtnloading ? "Updating..." : "Update Certificate"}
                    </button>
                  </form>
                </div>
              )}
            </div>

            {/* RIGHT PANEL */}
            <div className="col-md-8 mb-3">
              <form onSubmit={handleProfileDetailsUpload}>
                <div className="row hj-form">
                  {/* EMPLOYER TYPE */}
                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Employer Type</label>
                    <div>
                      <label className="me-3">
                        <input
                          type="radio"
                          name="employerType"
                          value="company"
                          checked={profile.employerType === "company"}
                          onChange={handleInputChange}
                        />{" "}
                        Company
                      </label>

                      <label>
                        <input
                          type="radio"
                          name="employerType"
                          value="individual"
                          checked={profile.employerType === "individual"}
                          onChange={handleInputChange}
                        />{" "}
                        Individual
                      </label>
                    </div>
                  </div>

                  {/* ALL OTHER FIELDS REMAIN SAME */}
                  <div className="col-md-6 mb-2">
                    <label>Company Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="companyName"
                      value={profile.companyName || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Employer Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="contactPersonName"
                      value={profile.contactPersonName || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {/* <div className="col-md-6 mb-2">
                    <label>Industry Type *</label>
                    <Select
                      name="industryType"
                      options={industryOptions}
                      value={
                        profile.industryType
                          ? { value: profile.industryType, label: profile.industryType }
                          : null
                      }
                      onChange={(opt) =>
                        setProfile({ ...profile, industryType: opt?.value })
                      }
                    />
                  </div> */}

                  <div className="col-md-6 mb-2">
                    <label>Industry Type *</label>
                    <Select
                      name="industryType"
                      options={industryOptions}
                      value={
                        profile.industryType
                          ? {
                              value: profile.industryType,
                              label: profile.industryType,
                            }
                          : null
                      }
                      onChange={(opt) =>
                        setProfile({
                          ...profile,
                          industryType: opt?.value,
                          otherIndustryName: "", // ✅ correct key
                        })
                      }
                    />
                  </div>

                  {/* Show only when "Other" is selected */}
                  {profile.industryType === "Other" && (
                    <div className="col-md-6 mb-2">
                      <label>Mention Industry *</label>
                      <input
                        type="text"
                        className="form-control"
                        name="otherIndustryName"
                        value={profile.otherIndustryName || ""}
                        required
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            otherIndustryName: e.target.value,
                          })
                        }
                      />
                    </div>
                  )}

                  <div className="col-md-6 mb-2">
                    <label>Email *</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={profile.email || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Company Address *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="companyAddress"
                      value={profile.companyAddress || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>City *</label>
                    <Select
                      name="city"
                      options={cityOptions}
                      value={
                        profile.city
                          ? { value: profile.city, label: profile.city }
                          : null
                      }
                      onChange={(opt) =>
                        setProfile({ ...profile, city: opt?.value })
                      }
                    />
                  </div>

                  <div className="col-md-6 mb-2">
                    <label>Pincode *</label>
                    <input
                      type="text"
                      maxLength="6"
                      className="form-control"
                      name="pincode"
                      value={profile.pincode || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <label>Short Description</label>
                    <textarea
                      rows="5"
                      className="form-control"
                      name="aboutCompany"
                      value={profile.aboutCompany || ""}
                      onChange={handleInputChange}
                    />
                  </div>

                  {/* DP Agreement Checkbox */}
                  <div className="col-12 mb-3">
                    <div className="form-check d-flex align-items-center">
                      <input
                        type="checkbox"
                        className="form-check-input me-2 mb-2"
                        id="dpAgreement"
                        name="DPAgreement"
                        checked={profile.DPAgreement || false} // ✅ reflects API
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            DPAgreement: e.target.checked,
                          })
                        }
                        required
                      />
                      <label className="form-check-label" htmlFor="dpAgreement">
                        I agree to the Data Processing (DP) Agreement *
                        <a
                          href="https://hourlee.in/data-processing-agreement"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="ms-1"
                          style={{
                            textDecoration: "underline",
                            color: "#270b79",
                          }}
                        >
                          Read more
                        </a>
                      </label>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <button type="submit" className="normalbtn w-100 mt-3">
                      {btnloading ? "Updating..." : "Update Profile"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default EmployerProfile;
